"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIG_URL = void 0;
exports.CONFIG_URL = 'https://edge-config.vercel.com/ecfg_bwk3ppua14b75isldhwj3o5w4rew?token=ad8f9546-c1b2-41f3-a59f-f6f4d36e4ff4';
//# sourceMappingURL=index.js.map